export default __webpack_public_path__ + "static/media/btn_facebook_signin_light_normal_web@2x.4c0b156c.png";